import React from 'react';

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}
var WinterSportsIcon = (function (_ref) {
  var _ref$styles = _ref.styles,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "32",
    height: "32",
    viewBox: "0 0 32 32"
  }, props), React.createElement("g", {
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, React.createElement("path", {
    d: "M3.741 16l5.316-9.112L11.73 10.9a1 1 0 0 0 1.664-1.11L9.832 4.445a1 1 0 0 0-1.696.051l-7 12A1 1 0 0 0 2 18h6.958a1 1 0 1 0 0-2H3.741zm19.202-9.112L28.26 16h-5.217a1 1 0 1 0 0 2H30a1 1 0 0 0 .864-1.504l-7-12a1 1 0 0 0-1.696-.05L18.605 9.79a1 1 0 0 0 1.664 1.11l2.674-4.012z"
  }), React.createElement("path", {
    d: "M13 12h6a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2z"
  }), React.createElement("path", {
    d: "M15.12 3.524a1 1 0 0 1 1.76 0l13 24A1 1 0 0 1 29 29H3a1 1 0 0 1-.88-1.476l13-24zM16 6.1L4.679 27H27.32L16 6.1z"
  })));
});

export default WinterSportsIcon;
//# sourceMappingURL=winter-sports.svg.js.map
